import React from 'react';
import { useImageUrl } from '@shared/components/ImageContext';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import ActiveRoundNote from './ActiveRoundNote';
import styles from './RunList.module.scss';

interface HistoryMessageDialogProps {
  headline: string;
  body: string;
  // Omitted while loading: there is nothing to do but wait.
  action?: { label: string; onClick: () => void };
  onClose: () => void;
}

// Empty, failed and loading all collapse to this: a message and a way out.
const HistoryMessageDialog: React.FC<HistoryMessageDialogProps> = ({
  headline,
  body,
  action,
  onClose,
}) => {
  const { t } = useTranslation();
  const { img, imgProps } = useImageUrl();

  return (
    <div className={styles.filterScrim}>
      <div
        className={styles.filterDialog}
        style={
          { '--panel-skin': `url(${img('PopupFrame')})` } as React.CSSProperties
        }
      >
        <div className={styles.filterHead}>
          <h2 className={styles.filterTitle}>{t('Player history')}</h2>
          <button
            type="button"
            className={styles.close}
            aria-label={t('Close')}
            onClick={onClose}
          >
            <img {...imgProps('Icon_Close')} alt="" />
          </button>
        </div>

        <p className={styles.banner}>{headline}</p>
        <p className={styles.messageBody}>{body}</p>

        {action && (
          <button
            type="button"
            className={cn(styles.apply, styles.tab_on)}
            style={
              {
                '--button-skin': `url(${img('ButtonSkin_Primary')})`,
              } as React.CSSProperties
            }
            onClick={action.onClick}
          >
            {action.label}
          </button>
        )}

        <ActiveRoundNote />
      </div>
    </div>
  );
};

export default HistoryMessageDialog;
